// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Marketplace } from './Marketplace';
import {
  MarketplaceFromJSON,
  MarketplaceFromJSONTyped,
  MarketplaceToJSON,
  MarketplaceToJSONTyped,
} from './Marketplace';

/**
 *
 * @export
 * @interface GetMarketplaceResponse
 */
export interface GetMarketplaceResponse {
  /**
   *
   * @type {Marketplace}
   * @memberof GetMarketplaceResponse
   */
  marketplace: Marketplace;
}

/**
 * Check if a given object implements the GetMarketplaceResponse interface.
 */
export function instanceOfGetMarketplaceResponse(
  value: object,
): value is GetMarketplaceResponse {
  if (!('marketplace' in value) || value['marketplace'] === undefined)
    return false;
  return true;
}

export function GetMarketplaceResponseFromJSON(
  json: any,
): GetMarketplaceResponse {
  return GetMarketplaceResponseFromJSONTyped(json, false);
}

export function GetMarketplaceResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetMarketplaceResponse {
  if (json == null) {
    return json;
  }
  return {
    marketplace: MarketplaceFromJSON(json['marketplace']),
  };
}

export function GetMarketplaceResponseToJSON(
  json: any,
): GetMarketplaceResponse {
  return GetMarketplaceResponseToJSONTyped(json, false);
}

export function GetMarketplaceResponseToJSONTyped(
  value?: GetMarketplaceResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    marketplace: MarketplaceToJSON(value['marketplace']),
  };
}
